import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [meetingsAllIds, meetingsById, allMeetingsSelector] =
  resourceSelectors('meetings');

export const upcomingMeetingsSelector = createSelector(
  allMeetingsSelector,
  (allIdMeetingss) => {
    return allIdMeetingss
      .filter((item) => new Date(item.startAt) > new Date())
      .sort((a, b) => new Date(a.startAt) - new Date(b.startAt));
  }
);

export const pastMeetingsSelector = createSelector(
  allMeetingsSelector,
  (allIdMeetingss) => {
    return allIdMeetingss
      .filter((item) => new Date(item.startAt) < new Date())
      .sort((a, b) => new Date(b.startAt) - new Date(a.startAt));
  }
);

export const upcomingMeetingsCountSelector = createSelector(
  upcomingMeetingsSelector,
  (meetings) => meetings.length
);
